module.exports = __webpack_public_path__ + "img/ccat.9b62e84a.png";